import React from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';
import * as Icon from 'react-feather';

function DeactivateConfirmModal({
    show,
    title,
    itemLabel,
    body,
    confirming,
    onCancel,
    onConfirm,
}) {
    return (
        <Modal show={show} onHide={onCancel} centered aria-labelledby="deactivate-confirm-modal">
            <Modal.Header closeButton>
                <Modal.Title id="deactivate-confirm-modal">
                    {title || 'Desactivar registro'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="d-flex gap-3 align-items-start">
                    <div className="text-danger mt-1">
                        <Icon.AlertTriangle size={22} />
                    </div>
                    <div>
                        <p className="mb-2">
                            {body || 'Este registro se desactivará y dejará de aparecer en las tablas principales.'}
                        </p>
                        {itemLabel && (
                            <Alert variant="light" className="border mb-0 py-2">
                                <strong>{itemLabel}</strong>
                            </Alert>
                        )}
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-secondary" onClick={onCancel} disabled={confirming}>
                    Cancelar
                </Button>
                <Button variant="danger" onClick={onConfirm} disabled={confirming}>
                    {confirming ? 'Desactivando...' : 'Desactivar'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default DeactivateConfirmModal;
